import { expectArray, expectString } from "./schema";
export const ROLES = ["public", "preMember", "parent", "teacher", "admin", "platformAdmin"];
export const MEMBER_ROLES = ["parent", "teacher", "admin"];
export function isRole(value) {
    return ROLES.includes(value);
}
export function isMemberRole(value) {
    return MEMBER_ROLES.includes(value);
}
export function parseRole(value, path = "role") {
    const role = expectString(value, path);
    if (!isRole(role)) {
        throw new Error(`${path} must be one of: ${ROLES.join(", ")}`);
    }
    return role;
}
export function parseMemberRole(value, path = "memberRole") {
    const role = expectString(value, path);
    if (!isMemberRole(role)) {
        throw new Error(`${path} must be one of: ${MEMBER_ROLES.join(", ")}`);
    }
    return role;
}
export function parseRoles(value, path = "roles") {
    return expectArray(value, parseRole, path);
}
export function parseMemberRoles(value, path = "member.roles") {
    return expectArray(value, parseMemberRole, path);
}
